import { SnapshotIn } from 'mobx-state-tree';
import { dropIgnoredAttachments } from './utils';
import { HouseChatAttachmentTabType } from './types';
import { ChatMessageModel, TMessageAttachmentSnapshot } from './models';
import {
  MaxMessageCreatedPayload,
  MaxSocketAttachmentDTO,
} from 'socket/events/max-chats';

// Соответствие "сырых" типов вложений из сокета вкладкам InfoColumn:
// фото приходят и как 'image', и как 'photo' в зависимости от источника.
const ATTACHMENT_TYPE_TO_TAB: Record<string, HouseChatAttachmentTabType> = {
  image: 'image',
  photo: 'image',
  video: 'video',
  audio: 'audio',
  voice: 'audio',
  file: 'file',
};

export const collectAttachmentTabTypes = (
  attachments: MaxSocketAttachmentDTO[] | null
): HouseChatAttachmentTabType[] => {
  const types = new Set<HouseChatAttachmentTabType>();

  (attachments ?? []).forEach((attachment) => {
    const tabType = ATTACHMENT_TYPE_TO_TAB[attachment.type];

    if (tabType) {
      types.add(tabType);
    }
  });

  return Array.from(types);
};

export const normalizeAttachments = (
  attachments: MaxSocketAttachmentDTO[] | null
): TMessageAttachmentSnapshot[] =>
  dropIgnoredAttachments(attachments ?? [])
    .filter((attachment) => attachment.id)
    .map((attachment) => ({
      id: attachment.id,
      type: attachment.type,
      url: null,
      filename: null,
      size: null,
      thumbnailUrl: null,
      duration: null,
    }));

export const normalizeMaxMessage = (
  payload: MaxMessageCreatedPayload
): SnapshotIn<typeof ChatMessageModel> => ({
  id: payload.max_message_id,
  max_message_id: payload.max_message_id,
  text: payload.text ?? null,
  created_at: new Date(payload.timestamp_ms).toISOString(),
  sender: payload.sender
    ? {
        max_user_id: payload.sender.user_id ?? null,
        first_name: payload.sender.first_name ?? null,
        last_name: payload.sender.last_name ?? null,
        is_bot: payload.sender.is_bot ?? false,
      }
    : null,
  system_sender: payload.system_sender
    ? {
        first_name: payload.system_sender.first_name ?? null,
        last_name: payload.system_sender.last_name ?? null,
        is_bot: false,
      }
    : null,
  has_attachments: !!payload.attachments?.length,
  attachments: normalizeAttachments(payload.attachments),
  reply_to_max_id: payload.reply_to_max_id ?? null,
  is_massive: payload.is_massive ?? false,
  is_repost: payload.is_repost ?? false,
  repost_sender: payload.repost_sender
    ? {
        user_id: payload.repost_sender.user_id ?? null,
        first_name: payload.repost_sender.first_name ?? null,
        last_name: payload.repost_sender.last_name ?? null,
        username: payload.repost_sender.username ?? null,
        name: payload.repost_sender.name ?? null,
        is_bot: payload.repost_sender.is_bot ?? false,
      }
    : null,
  repost_source_chat_id: payload.repost_source_chat_id ?? null,
  reply_preview: payload.reply_preview
    ? {
        sender_name: payload.reply_preview.sender_name,
        preview: payload.reply_preview.preview,
        is_deleted: payload.reply_preview.is_deleted ?? false,
      }
    : null,
  system_message: payload.system_message ?? null,
});
